import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Breadcrumb, BreadcrumbProps } from 'antd'
import cls from 'classnames'
import { useCssInJs } from 'hooks/useCssInJs'
import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { genLayoutStyle } from './styles'
import { Menu } from './menu'
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import { UserInfo } from './user'
import { ENV } from './env'
import LazyComponent from 'components/LazyComponent'
// import { ReactComponent as Logo } from 'assets/svg/logo.svg'

type MenuItem = Required<MenuProps>['items'][number]

type AppConfig = {
  appCode: string
}
type Props = {
  config: AppConfig
} & PropsWithChildren

type TLayoutContext = {
  config: AppConfig
  collapsed?: boolean
  setCollapsed: (collapsed: boolean | ((collapsed: boolean) => boolean)) => void
  baseBreadcrumb?: BreadcrumbItemType[]
  setBaseBreadcrumb: React.Dispatch<React.SetStateAction<BreadcrumbItemType[]>>
  breadcrumb: BreadcrumbItemType[]
  setBreadcrumb: React.Dispatch<React.SetStateAction<BreadcrumbItemType[]>>
}

export const LayoutContext = React.createContext<TLayoutContext>(null!)

export function useLayout() {
  return useContext(LayoutContext)
}

export function LayoutProvider(props: Props) {
  const { children, config } = props
  const [collapsed, setCollapsed] = useState(
    localStorage['collapsed'] === 'true' || false
  )

  const [baseBreadcrumb, setBaseBreadcrumb] = useState<BreadcrumbItemType[]>([])
  const [breadcrumb, setBreadcrumb] = useState<BreadcrumbItemType[]>([])

  useEffect(() => {
    localStorage['collapsed'] = collapsed
  }, [collapsed])
  return (
    <LayoutContext.Provider
      value={{
        config,
        collapsed,
        setCollapsed,
        breadcrumb,
        setBreadcrumb,
        baseBreadcrumb,
        setBaseBreadcrumb,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export function Layout(props: PropsWithChildren) {
  const { children } = props
  const { collapsed, setCollapsed, baseBreadcrumb, breadcrumb } = useLayout()
  const prefix = 'layout'
  const { wrapSSR, hashId } = useCssInJs({
    prefix: 'layout',
    styleFun: genLayoutStyle,
  })

  // const finalBreadcrumb = useMemo(() => {
  //   return [...baseBreadcrumb, ...breadcrumb]
  // }, [baseBreadcrumb, breadcrumb])

  return wrapSSR(
    <div className={cls(prefix, hashId, collapsed ? 'collapsed' : '')}>
      <div className='slider'>
        <div className='logo'>
          <h1>
            {/* <Logo className='svg' /> */}
            <span>米村伙伴协同平台</span>
          </h1>
        </div>
        <div className='menu'>
          <Menu />
        </div>
      </div>
      <div className='layout'>
        <div className='header'>
          <div className='tools'>
            <div
              onClick={() => setCollapsed((v) => !v)}
              className='button-collapse'
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>
            <div className='userinfo'>
              <ENV />
              <UserInfo />
            </div>
          </div>
          {/* {finalBreadcrumb.length ? (
            <Breadcrumb className='breadcrumb' items={finalBreadcrumb} />
          ) : (
            <div className='breadcrumb' />
          )} */}
          {/* <div className='breadcrumb' /> */}
        </div>
        <div className='content'>
          <LazyComponent>{children}</LazyComponent>
        </div>
      </div>
    </div>
  )
}
